export const questionConfig = {
	'liste noire': ['transport . voiture . aide km'],
}
